import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import capitalize from '~/utils/string';

interface ApiErrorProps {
  errorCode?: string;
  onClose?: () => void;
}

const ApiError = ({ errorCode = '0', onClose }: ApiErrorProps) => {
  const { t } = useTranslation('errors');
  const [time, setTime] = useState(0);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      onClose();
    }, 5000);

    const intervalId = setInterval(() => {
      setTime((value) => value + 10);
    }, 10);

    return () => {
      clearTimeout(timeoutId);
      clearTimeout(intervalId);
    };
  }, []);

  return (
    <div className="overflow-hidden rounded-lg shadow-lg relative">
      <div className="max-w-md p-4 space-y-4 bg-white pointer-events-auto ring-1 ring-black ring-opacity-5">
        <div className="flex">
          <div>
            <svg
              className="h-5 w-5 text-red-400 mt-1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <div className="ml-3 pt-0.5">
            <p className="text-md text-gray-900">{capitalize(t(errorCode))}</p>
            {errorCode === '0' && (
              <p className="mt-1 text-sm text-gray-500">
                {capitalize(
                  t(
                    'Neem contact op met support@bitsoflove.be indien het probleem zich blijft voordoen.',
                  ),
                )}
              </p>
            )}
          </div>
          <div className="ml-4">
            {onClose && (
              <button
                type="button"
                className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                onClick={onClose}
              >
                <span className="sr-only">Close</span>
                <svg
                  className="h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            )}
          </div>
        </div>
      </div>
      <div
        className="h-0.5 z-10 bg-red-300 absolute left-0 bottom-0"
        style={{ width: `${(time / 5000) * 100}%` }}
      />
      <div className="h-0.5 w-full bg-red-100 absolute left-0 bottom-0" />
    </div>
  );
};

export default ApiError;
